import { createSelector } from '@reduxjs/toolkit'

import { initialState } from '.'
import { RootState } from '../../../../types'

const selectDomain = (state: RootState) =>
  typeof state !== 'undefined'
    ? state.loginFormComponent || initialState
    : initialState

const selectLoginFormAsyncError = createSelector(
  [selectDomain],
  (state) => state.loginFormAsyncError
)

const selectIsLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading
)

const selectAuth = createSelector([selectDomain], (state) => state.auth)

export { selectLoginFormAsyncError, selectIsLoading, selectAuth }
